import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DefaultReactiveComponent} from '@shared/default-reactive/default-reactive.component';
import {GridNew} from '@shared/grid-new';
import {GridEvent, GridEventType} from '@shared/grid-new/shared/grid-new-event-types';
import {GridNewService} from '@shared/grid-new/shared/grid-new.service';
import {Opportunity} from '@shared/opportunity';
import {navigateToDetailsIfIdentifiable} from '@shared/routing';
import {InstitutionsService} from '../institutions.service';
import {FilterData} from '@shared/filter-data';
import {Sort} from '@angular/material/sort';

@Component({
    selector: 'phscw-institutions-opportunities',
    standalone: false,
    templateUrl: './institutions-opportunities.component.html',
    styleUrl: './institutions-opportunities.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstitutionsOpportunitiesComponent
    extends DefaultReactiveComponent
    implements GridNew<Opportunity>, OnInit {
    // Grid-Name für Events und Konfiguration
    gridName = 'institutions-opportunities';

    // Grid-Konfiguration
    entityName = 'opportunities';
    displayedColumnsName = 'institutionsOpportunities';
    gridDataBackendUrl = 'crud/opportunities/read/';
    routerBasePath = '/opportunities';

    // Initiale Sortierung des grids
    initialSort: Sort = {
        active: 'end_date',
        direction: 'desc',
    };

    // Aktuell ausgewählte Einrichtung
    institutionId = 0;
    gridFilter: FilterData | null = null;

    constructor(
        private institutionsService: InstitutionsService,
        private gridNewService: GridNewService<Opportunity>,
        private router: Router,
        private cdr: ChangeDetectorRef,
    ) {
        super();
    }

    ngOnInit(): void {
        this.initializeInstitutionSelection();
        this.listenForGridEvents();
    }

    // Reagiert auf die aktuelle Auswahl der Einrichtung und auf Folgeänderungen
    private initializeInstitutionSelection(): void {
        const currentId = this.institutionsService.selectedInstitution?.id ?? 0;
        this.setInstitution(currentId);

        this.subscribeUntilDestroyed(this.institutionsService.selectionChanged, (institutionId: number) => {
            this.setInstitution(institutionId);
        });
    }

    /*
     * Setzt die gewählte Einrichtung
     * Über den GridFilter werden die opportunities der gewählten Einrichtung gefiltert, so muss kein extra Crud-Endpunkt verwendet werden
     */
    private setInstitution(institutionId: number): void {
        this.institutionId = institutionId ?? 0;

        if (this.institutionId > 0) {
            this.gridFilter = {
                label: 'institution',
                key: 'institution',
                formular: {
                    institution_id: this.institutionId,
                },
            };
        } else {
            this.gridFilter = null;
        }

        this.cdr.markForCheck();
    }

    // Navigation zur Opportunity-Detailansicht
    private listenForGridEvents(): void {
        this.subscribeUntilDestroyed(this.gridNewService.events$, (event: GridEvent<Opportunity>) => {
            if (event.sender !== this.gridName) {
                return;
            }

            if (event.type === GridEventType.SelectionChanged) {
                navigateToDetailsIfIdentifiable(this.router, this.routerBasePath, event.entity);
            }
        });
    }
}
